import React, { useState, useEffect } from 'react';
import { Button, TextField, Backdrop, CircularProgress } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useSnackbar } from 'notistack';

import Api from '../../../Api';
import Modal from '../../../components/Modal/Modal';

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    maxHeight: 'calc(100vh - 200px) !important'
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1000,
    color: '#fff'
  }
}));

const RenameFileModal = ({ handleClose, visibility, file }) => {
  const { enqueueSnackbar } = useSnackbar();
  const styles = useStyles();

  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setName(file ? file.name || '' : '');
  }, [file, visibility]);

  const handleCloseDismiss = () => {
    handleClose();
  };

  const handleSubmit = event => {
    event.preventDefault();
    setLoading(true);

    Api.put('/drive_files/' + file.id, { name })
      .then(function() {
        setLoading(false);
        enqueueSnackbar('Archivo renombrado exitosamente!', {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'success'
        });
        handleClose(true);
      })
      .catch(function(error) {
        setLoading(false);
        var message = 'Error de conexion, contacta a soporte';
        if (error.response) {
          message = 'Ocurrio un error, intenta nuevamente.';
        }
        enqueueSnackbar(message, {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'error'
        });
      });
  };

  return (
    <div>
      <Modal handleClose={handleCloseDismiss} visibility={visibility} title="Renombrar Archivo" maxWidth="sm">
        <form onSubmit={handleSubmit}>
          <DialogContent dividers>
            <TextField
              autoFocus
              fullWidth
              label="Nombre del archivo"
              name="name"
              type="text"
              onChange={e => setName(e.target.value)}
              value={name || ''}
              variant="outlined"
            />
          </DialogContent>
          <DialogActions>
            <Button disabled={!name || !name.trim()} type="submit" color="primary">
              Guardar
            </Button>
          </DialogActions>
        </form>
      </Modal>
      <Backdrop className={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default RenameFileModal;
